export const ROUTES_WITHOUT_HEADER: RegExp[] = [
  // Full-screen engagement detail (legacy hub + engagements-next steps); the list keeps its header.
  /^\/main\/engagements\/\d+([/?].*)?$/,
  // The app-level error page: reached from full-screen flows, and a header offering navigation
  // away is the wrong thing to put next to a "Try again" that goes back to what failed.
  /^\/main\/error\/[^/?]+([/?].*)?$/,
  // NOTE: the CXP request-detail route (/main/tasks/request/:id) used to hide the global
  // header because it rendered the legacy ClientRequestPanelComponent full-screen. The
  // redesigned page (cxp-new-crl-page) is a full LIST page that should show the header, and
  // its per-item detail is an overlay with its own nav bar — so that entry was removed (the
  // original comment said to remove it once CXP had its own detail view, which it now does).
  // Side effect: the flag-OFF legacy detail now also shows the global header (acceptable; it
  // has its own internal header and is being deprecated).
];
